import { exportsModule } from '@cian/mf-registry/browser';

import { type IApplicationContext } from 'shared/types/applicationContext';
import { RUNTIME_NAME } from 'shared/constants/microfrontend';

import { createMicrofrontendUI } from '../createMicrofrontendUI';

export function runApp(context: IApplicationContext): void {
  exportsModule({
    ui: {
      [RUNTIME_NAME]: createMicrofrontendUI(context),
    },
  });
}
